<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row class="mb-4">
            <v-col cols="12" sm="12" md="5">
              <label class="field-label">
                Text Group Name
                <span style="color: red;">*</span>
                <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Name this text group to easily identify its purpose</span>
                  </v-tooltip>
              </label>
              <v-text-field id="textgroupname-field-replacetext" placeholder="Text Group Name" v-model="ReplaceText.Name"
                variant="outlined" density="compact" color="primary" class="modern-text-field ml-6" clearable
                hide-details="auto" :readonly="!!ReplaceText.GroupReplaceID" :disabled="!!ReplaceText.GroupReplaceID">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <h1 style="font-weight: 600; font-size: 28px;" class="ml-5">Text List</h1>
            </v-col>
            <v-col cols="12" md="7" class="d-flex justify-end align-center pr-10">
              <a id="downloadtemplate-replacetext" @click="DownloadTemplate()" class="download-link mr-4"
                style="cursor: pointer;">
                <v-img :src="images.downloadImg" width="20" height="20" class="mr-2"></v-img>
                Template
                <v-tooltip activator="parent" location="top">
                  Download Template
                </v-tooltip>
              </a>

              <!-- Custom Upload Button -->
              <v-btn id="button-upload-replacement" @click="triggerFileUpload" variant="outlined"
                size="large" class="upload-btn mr-3">
                <v-img :src="images.uploadIcon" width="23" height="23"></v-img>
                <span class="btn-text">Upload</span>
                <v-tooltip activator="parent" location="top">
                  Upload CSV , Excel File
                </v-tooltip>
              </v-btn>

              <!-- Hidden DragDropFile Component -->
              <DragDropFile ref="dragDropFileRef" :dialog="false" :DragDrop="false" :ShowListFile="false"
                :allowType="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']"
                accept=".csv, .xlsx" @filesUploaded="processUpload($event)" style="display: none;" />

              <v-btn id="button-add-replacement" @click="Add()" variant="flat" color="primary" size="large"
                class="control-btn create-btn ml-3" prepend-icon="mdi-plus">
                Add Text
                <v-tooltip activator="parent" location="top">
                  Add Text Group
                </v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table-server :items-per-page="itemsPerPage" :items-length="searchTotalTable" v-model:options="options"
            :items="menus" :headers="headers" :loading="dialog" class="pa-5">
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.number }}</td>
                <td>{{ item.focusKey }}</td>
                <td>{{ item.replaceKey.length > 20 ? item.replaceKey.substring(0, 20) + '...' : item.replaceKey }}</td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center;">
                    <!-- Edit -->
                    <v-btn id="button-edit-popupedit-replacement" variant="text" density="comfortable"
                      @click="Edit(item)" class="action-btn edit-btn" icon>
                      <v-img :src="images.editBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        Edit
                      </v-tooltip>
                    </v-btn>
                    <!-- Delete -->
                    <v-btn id="button-delete-popupedit-replacement" variant="text" density="comfortable"
                      @click="DeleteReplaceText(item.replaceID)" class="action-btn delete-btn" icon>
                      <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
             <!-- 👇 Custom footer area -->
            <template v-slot:bottom>
              <div
                class="d-flex justify-space-between align-center px-4 py-2"
                style="width: 100%"
              >
                <div>Total results {{ searchTotalTable }}</div>

                <v-data-table-footer
                  v-model:items-per-page="itemsPerPage"
                  :page="options.page"
                  :length="Math.ceil(searchTotalTable / itemsPerPage)"
                />
              </div>
            </template>
            <!-- No Data Slot -->
            <template v-slot:no-data>
              <div class="no-data-container">
                <div class="no-data-content">
                  <h3 style="color: #646464!important;">No Data Available</h3>
                </div>
              </div>
            </template>
          </v-data-table-server>
        </v-flex>
        <br />
      </v-card>
    </v-container>

    <!-- Loading Please Wait... -->
    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <!-- Edit Dialog -->
    <v-dialog v-model="Editdialog" max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">{{ $t('edit') }} Text</h2>
              <p class="dialog-subtitle">Modify the replacement text</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="closeEditDialog" class="close-button" color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="6">
              <div class="field-container">
                <label class="field-label ml-0">
                  Original Text
                  <span style="color: red;">*</span>
                </label>
                <v-textarea id="specifictext-field-popupadd-replacement"
                  v-model="ReplaceText.FocusKey" :rules="[rules.required]" variant="outlined" density="comfortable"
                  color="primary" class="modern-field textarea" hide-details="auto" auto-grow>
                </v-textarea>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="field-container">
                <label class="field-label ml-0">
                  Replacement Text
                  <span style="color: red;">*</span>
                </label>
                <v-textarea id="replacementtext-field-popupadd-replacement"
                  v-model="ReplaceText.ReplaceKey" :rules="[rules.required]" variant="outlined" density="comfortable"
                  color="primary" class="modern-field textarea" hide-details="auto"
                  :error="errorMessage.replacementText.isRequired"
                  :error-messages="errorMessage.replacementText.required" auto-grow>
                </v-textarea>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" color="grey" size="large" @click="closeEditDialog" class="cancel-btn">
            Discard
          </v-btn>
          <v-btn id="button-save-popupedit-replacement" variant="flat" size="large" @click="SaveEdit()"
            class="dialog-action-btn save-btn-edit">
            <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
            {{ $t('save') }} Changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Dialog -->
    <v-dialog v-model="Adddialog" max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">{{ $t('add') }} Text</h2>
              <p class="dialog-subtitle">Add new replacement text</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="closeAddDialog" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="6">
              <div class="field-container">
                <label class="field-label ml-0">
                  Original Text
                  <span style="color: red;">*</span>
                </label>
                <v-textarea id="originaltext-field-popupadd-replacement" placeholder="Enter Original Text"
                  v-model="ReplaceText.FocusKey" :rules="[rules.required]" variant="outlined" density="comfortable"
                  color="primary" class="modern-field textarea" hide-details="auto" :error="errorMessage.originalText.isRequired"
                  :error-messages="errorMessage.originalText.required"
                  auto-grow>
                </v-textarea>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="field-container">
                <label class="field-label ml-0">
                  Replacement Text
                  <span style="color: red;">*</span>
                </label>
                <v-textarea id="replacementtext-field-popupadd-replacement" placeholder="Enter Replacement Text"
                  v-model="ReplaceText.ReplaceKey" :rules="[rules.required]" variant="outlined" density="comfortable"
                  color="primary" class="modern-field textarea" hide-details="auto"
                  :error="errorMessage.replacementText.isRequired"
                  :error-messages="errorMessage.replacementText.required"
                  auto-grow>
                </v-textarea>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" color="grey" size="large" @click="closeAddDialog" class="cancel-btn">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn id="button-save-popupadd-replacement" variant="flat" size="large" @click="SaveAdd()"
            class="dialog-action-btn save-btn-add">
            <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete Text</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            Are you sure you want to delete this text? This action cannot be undone.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Upload Dialog -->
    <v-dialog v-model="dialog_upload" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="upload-dialog-header">
          <span class="upload-dialog-title">Import Replacement Text</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="dialog_upload = false"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
            Do you want to Import a Replacement Text ?
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="dialog_upload = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="control-btn create-btn customadd"
            @click="Save()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <!-- Custom Warning Dialog -->
    <v-dialog v-model="dialog_warn" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="warn-dialog-header">
          <span class="reprocess-dialog-title">Text Information is Required !</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="dialog_warn = false"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
            Please fill in all required information.
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="reprocess-confirm-btn"
            @click="dialog_warn = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import DragDropFile from '@/components/DragDropFile.vue';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
import uploadIcon from "@/assets/images/uploadcolor.png";
import saveImg from '@/assets/images/savecard.png';
import downloadImg from '@/assets/images/downloadtemplate.svg';
export default {
  name: 'ReplaceText',
  inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
  mixins: [checkPermissionTwo],
  components: { DragDropFile },
  data: () => ({
    isInitialized: false,
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    dialog: false,
    valid: true,
    tempID: 0,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {},
    rules: {
      required: (value) => !!value || 'Required.',
    },
    searchName: '',
    isSearch: false,
    isFirst: true,
    menus: [],
    images: {
      edit: editImg,
      delete: deleteImg,
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      deleteIcon: deleteIcon,
      uploadIcon: uploadIcon,
      saveImg: saveImg,
      downloadImg: downloadImg
    },
    dialog_delete: false,
    deleteItem: null,
    dialog_upload: false,
    dialog_warn: false,
    ReplaceText: {
      GroupReplaceID: null,
      Name: null,
      ReplaceID: null,
      FocusKey: null,
      ReplaceKey: null,
    },
    files: [],
    uploadedFiles: [],
    entity: null,
    sortBy: [],
    sortDesc :[],

    errorMessage : {
      originalText: {
        required: '',
        isRequired : false,
      },
      replacementText: {
        required: '',
        isRequired : false,
      },
    }
  }),
  computed: {
    headers() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false, width: '95px' },
        { title: 'Original Text', align: 'left', sortable: true,value:'FocusKey' },
        { title: 'Replacement Text', align: 'left', sortable: true ,value:'ReplaceKey'},
        { title: 'Action', align: 'center', sortable: false, width: '150px' },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },

    'ReplaceText.FocusKey'(val) {
      if (val) {
        this.errorMessage.originalText.isRequired = false;
        this.errorMessage.originalText.required = '';
      }
    },
    'ReplaceText.ReplaceKey'(val) {
      if (val) {
        this.errorMessage.replacementText.isRequired = false;
        this.errorMessage.replacementText.required = '';
      }
    },
  },
  methods: {
    
    triggerFileUpload() {
      // กดที่ DragDropFile component ผ่าน ref
      if (this.$refs.dragDropFileRef) {
        // หาค element ที่เป็น input file หรือ button ใน DragDropFile component
        const fileInput = this.$refs.dragDropFileRef.$el.querySelector('input[type="file"]');
        const uploadButton = this.$refs.dragDropFileRef.$el.querySelector('button');
        
        if (fileInput) {
          fileInput.click();
        } else if (uploadButton) {
          uploadButton.click();
        }
        // หรือถ้า DragDropFile มี method เปิด dialog
        // this.$refs.dragDropFileRef.openDialog();
      }
    },
    Get() {
      let self = this;
      self.dialog = true;
      
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        id: self.ReplaceText.GroupReplaceID,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      self.$call.GetTableReplaceText(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data.listReplaceText;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    Add() {
      let self = this;
      self.ReplaceText.ReplaceID = null;
      self.ReplaceText.FocusKey = null;
      self.ReplaceText.ReplaceKey = null;
      self.Adddialog = true;
    },
    Edit(item) {
      let self = this;
      self.Editdialog = true;
      self.ReplaceText.ReplaceID = item.replaceID;
      self.ReplaceText.FocusKey = item.focusKey;
      self.ReplaceText.ReplaceKey = item.replaceKey;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    async SaveAdd() {
      let self = this;

      if ((self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') ||
          (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '')
      ) {
        if (self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') {
          self.errorMessage.originalText.required = 'Required';
          self.errorMessage.originalText.isRequired = true;
        }
        if (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '') {
          self.errorMessage.replacementText.required = 'Required';
          self.errorMessage.replacementText.isRequired = true;
          
        }
        return;
      }
      if (
        self.ReplaceText.Name == null ||
        self.ReplaceText.Name == ''
        // self.ReplaceText.FocusKey == null ||
        // self.ReplaceText.FocusKey == '' ||
        // self.ReplaceText.ReplaceKey == null ||
        // self.ReplaceText.ReplaceKey == ''
      ) {
        self.dialog_warn = true;
        return;
      }
      self.dialog = true;
      try {
        if (self.ReplaceText.GroupReplaceID == null) {
          let list = [{ FocusKey: self.ReplaceText.FocusKey, ReplaceKey: self.ReplaceText.ReplaceKey }];
          let temp = {
            GroupReplaceID: null,
            Name: self.ReplaceText.Name,
            ListReplaceText: list,
          };
          await self.$call.CreateGroupReplace(
            temp,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                if (dataResponse.data == -1) {
                  self.$swal.fire({
                    icon: 'warning',
                    title: 'Group name is duplicate',
                    showConfirmButton: false,
                    timer: 1800,
                  });
                } else {
                  self.$swal.fire({
                    title: "✔ Text Saved Successfully!",
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                  });
                  self.ReplaceText.GroupReplaceID = dataResponse.data;
                  self.totalTable = self.totalTable+1;
                  self.Get();

                  //  repalace the current route query parameters not reload the page
                  const currentQuery = { ...this.$route.query };
                  currentQuery.name = self.ReplaceText.Name;
                  currentQuery.id = dataResponse.data;
                  self.$router.replace({
                    path: this.$route.path,
                    query: currentQuery,
                  });
                }
                self.Adddialog = false;
              }else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Group name is duplicate',
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else {
          // ReplaceText.Name
          let temp = {
            GroupReplaceID: self.ReplaceText.GroupReplaceID,
            Name: self.ReplaceText.Name,
            FocusKey: self.ReplaceText.FocusKey,
            ReplaceKey: self.ReplaceText.ReplaceKey,
          };
          await self.$call.CreateReplaceText(
            temp,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Text Updated Successfully !",
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                });
                self.totalTable = self.totalTable+1;
                self.Get();
                self.Adddialog = false;

                //  repalace the current route query parameters not reload the page
                  const currentQuery = { ...this.$route.query };
                  currentQuery.name = self.ReplaceText.Name;
                  currentQuery.id = dataResponse.data;
                  self.$router.replace({
                    path: this.$route.path,
                    query: currentQuery,
                  });
              }
              else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Group name is duplicate',
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              console.log(dataResponse);
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    async SaveEdit() {
      let self = this;

      if ((self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') ||
          (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '')
      ) {
        if (self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') {
          self.errorMessage.originalText.required = 'Required';
          self.errorMessage.originalText.isRequired = true;
        }
        if (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '') {
          self.errorMessage.replacementText.required = 'Required';
          self.errorMessage.replacementText.isRequired = true;
          
        }
        return;
      }
      self.dialog = true;
      try {
        if (self.Editdialog) {
          let temp = {
            GroupReplaceID: self.ReplaceText.GroupReplaceID,
            Name: self.ReplaceText.Name,
            ReplaceID: self.ReplaceText.ReplaceID,
            FocusKey: self.ReplaceText.FocusKey,
            ReplaceKey: self.ReplaceText.ReplaceKey,
          };
          await self.$call.UpdateReplaceText(
            temp,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Text Updated Successfully !",
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                });
                self.Get();
                self.Editdialog = false;
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    DeleteReplaceText(id) {
      let self = this;
      self.deleteItem = id;
      self.dialog_delete = true;
      
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;
      var id = self.deleteItem
      try {
        self.dialog_delete = false;
            self.dialog = true;
            self.$call.DeleteReplaceText(
              id,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  self.dialog = false;
                  self.$swal.fire({
                    title: "✔ Text Successfully Deleted !",
                    showConfirmButton: false,
                    timer: 1500,
                     position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                  });
                  self.Get();
                }
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                console.error(errorResource);
              }
            );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    DownloadTemplate() {
      const data = [
        ['Text', 'Replace_Text'],
        ['ฟุตบอล', 'Football'],
        ['ปิงปอง', 'pingpong'],
      ];
      // จัดรูปแบบข้อมูลในรูปแบบของ CSV
      const csvContent = data.map((row) => row.join(',')).join('\n');
      const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvContent], { type: 'text/csv;charset=utf-8;' });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      link.download = 'replace_text_template.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        this.ValidateFile(this.files);
        this.ConfirmProcess();
      };
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append('uploaded_file', files[0]);
      this.uploadedFiles = files;
      this.entity = formDataDoc;
    },
    ConfirmProcess() {
      let self = this;
      self.dialog_upload = true;
    },

    Save() {
      let self = this;
      if (!self.ReplaceText.Name) {
         self.dialog_warn = true;
        return;
      }
      self.dialog = true;
      self.dialog_upload = false;
      try {
        let temp = {
          groupName: self.ReplaceText.Name,
          uploaded_file: self.entity,
          groupReplaceID: self.ReplaceText.GroupReplaceID,
          DeleteAll: false,
        };
        self.$call.UploadFileReplaceText(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.groupReplaceID == 0) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Format Excel/CSV incorrect',
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else if (dataResponse.data.groupReplaceID == -1) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Group name is duplicate',
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else {
                self.$swal.fire({
                  title: "✔ Successfully Imported !",
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                });
                self.ReplaceText.GroupReplaceID = dataResponse.data.groupReplaceID;
                self.totalTable = dataResponse.data.totalPage;
                self.isFirst = true;
              }
              self.uploadedFiles = [];
              self.Get();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },

    closeAddDialog() {
      this.Adddialog = false;
      this.ReplaceText.FocusKey = null;
      this.ReplaceText.ReplaceKey = null;
      this.errorMessage.originalText.isRequired = false;
      this.errorMessage.originalText.required = '';
      this.errorMessage.replacementText.isRequired = false;
      this.errorMessage.replacementText.required = '';
    },
    closeEditDialog() {
      this.Editdialog = false;
      this.ReplaceText.FocusKey = null;
      this.ReplaceText.ReplaceKey = null;
      this.errorMessage.originalText.isRequired = false;
      this.errorMessage.originalText.required = '';
      this.errorMessage.replacementText.isRequired = false;
      this.errorMessage.replacementText.required = '';
    },
  },
  mounted() {
    this.GetDate();
    if (this.$route.query.id) {
      this.ReplaceText.Name = this.$route.query.name;
      this.ReplaceText.GroupReplaceID = this.$route.query.id;
    }
    this.Get();
    this.isInitialized = true;
  },
};
</script>

<style scoped>
/* =============================================================================
   BASE STYLES (from PromptTemplate.vue)
   ============================================================================= */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* =============================================================================
   TEXT FIELD STYLES (from PromptTemplate.vue)
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
}

.modern-text-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-text-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Read-only state */
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-field--readonly:hover .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

/* Label and input styling */
.modern-text-field :deep(.v-label) {
  font-weight: 400 !important;
  color: #CCC !important;
  font-size: 0.875rem !important;
}

.modern-text-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-text-field :deep(.v-field--readonly .v-label) {
  color: #CCC !important;
}

.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 400 !important;
  color: #171717 !important;
  padding: 16px 12px !important;
  text-transform: none !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

/* Icon styling */
.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* =============================================================================
   BUTTON STYLES (from PromptTemplate.vue)
   ============================================================================= */
.add-replacement-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  border-radius: 12px !important;
  padding: 8px 24px !important;
  min-width: 160px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 3px 12px rgba(25, 118, 210, 0.3) !important;
}

.add-replacement-btn:hover {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.download-link {
  color: #C32E0E !important;
  text-decoration: none !important;
  font-weight: 400 !important;
  font-size: 0.875rem !important;
  display: flex !important;
  align-items: center !important;
  transition: all 0.3s ease !important;
  padding: 8px 12px !important;
  border-radius: 16px !important;
}

.download-link:hover {
  background: #FDE4DF;
  text-decoration: none !important;
}

/* =============================================================================
   DATA TABLE STYLES (from PromptTemplate.vue)
   ============================================================================= */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.action-divider {
  width: 1px;
  height: 20px;
  background: #dee2e6;
  margin: 0 8px;
  transition: all 0.3s ease;
}

.action-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* =============================================================================
   DIALOG STYLES (from PromptTemplate.vue)
   ============================================================================= */
/* .modern-dialog :deep(.v-overlay) {
  z-index: 200 !important;
}

.modern-dialog :deep(.v-overlay__content) {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 201 !important;
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

.dialog-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  padding: 24px !important;
  position: relative;
  border-bottom: none !important;
}

.header-icon-container {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.header-text {
  flex: 1;
} */

/* .dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
} */

/* .dialog-subtitle {
  font-size: 0.875rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  font-weight: 400 !important;
} */

/* .close-btn {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: scale(1.1) !important;
} */

.dialog-content {
  padding: 32px 24px !important;
  background: #ffffff;
}

.field-container {
  margin-bottom: 16px;
}

.modern-field :deep(.v-field__outline) {
  border-radius: 12px !important;
}

.modern-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.dialog-actions {
  background: rgba(248, 249, 250, 0.5) !important;
  padding: 20px 24px !important;
  gap: 12px;
}

.cancel-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.save-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.save-edit-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(255, 164, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-edit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 164, 7, 0.4) !important;
}
/* =============================================================================
   UPLOAD BUTTON STYLES
   ============================================================================= */
.upload-btn {
  background: #ffffff !important;
  border: 1px solid #C32E0E !important;
  color: #C32E0E !important;
  font-weight: 400 !important;
  letter-spacing: 0.5px !important;
  border-radius: 12px !important;
  padding: 8px 24px !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
}

.upload-btn:hover {
  color: #C32E0E !important;
  transform: translateY(-2px) !important;
  border: 1px solid var(--main, #C32E0E);
  background: #FDE4DF;
}

.upload-btn .v-icon {
  transition: transform 0.3s ease !important;
}

.upload-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Upload States */
.upload-btn.uploading {
  background: #ffc107 !important;
  border-color: #ffc107 !important;
  color: #212529 !important;
  pointer-events: none;
}

.upload-btn.success {
  background: #28a745 !important;
  border-color: #28a745 !important;
  color: #ffffff !important;
  animation: successPulse 0.5s ease;
}

@keyframes successPulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Button Text Animation */
.btn-text {
  transition: all 0.3s ease;
  position: relative;
}

.upload-btn:hover .btn-text {
  transform: translateX(2px);
}

/* Responsive Upload Button */
@media (max-width: 768px) {
  .upload-btn {
    min-width: 120px !important;
    padding: 6px 16px !important;
  }
  
  .upload-btn .btn-text {
    font-size: 0.875rem;
  }
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 768px) {
  .modern-text-field :deep(.v-field__input) {
    font-size: 0.9rem !important;
    padding: 14px 10px !important;
  }
  
  .modern-text-field :deep(.v-label) {
    font-size: 0.8rem !important;
  }

  .dialog-header {
    padding: 20px 16px !important;
  }
  
  .header-icon-container {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }
  
  .dialog-title {
    font-size: 1.25rem !important;
  }
  
  .dialog-content {
    padding: 24px 16px !important;
  }
  
  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }
  
  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-pagination__first),
:deep(.v-pagination__last) {
  display: none !important;
}
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
.field-label {
  margin-bottom: 4px;
  color: #171717;
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 20px;
}
.no-data-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.textarea :deep(.v-field__input) {
  min-height: 150px !important;
  height: 300px !important;
  overflow-y: auto !important;
}
</style>
